import React from "react";

const ProfitLossTable = ({ model }) => {
  const years = [1, 2, 3, 4, 5, 6, 7];

  const formatNumber = (value) => {
    if (value === undefined || value === null) return "0";
    const rounded = Math.round(value);
    return rounded.toLocaleString("ru-RU");
  };

  const formatPercent = (value) => {
    if (value === undefined || value === null) return "0%";
    const percent = value * 100;
    if (percent < 0) return "убыток";
    return Math.round(percent) + "%";
  };

  const negativeClass = (value) => (value < 0 ? "red" : "");
  const negativePercentClass = (value) => (value < 0 ? "red" : "");

  return (
    <div className="table-container">
      <table className="table" id="ProfitAndLoss">
        <caption className="table-caption">
          Прогноз финансовых результатов и анализ эффективности на 7 лет.
        </caption>
        <thead className="table-fields">
          <tr>
            <th>НАИМЕНОВАНИЕ</th>
            <th>ПЕРИОД 7 ЛЕТ</th>
            <th>1-й год</th>
            <th>2-й год</th>
            <th>3-й год</th>
            <th>4-й год</th>
            <th>5-й год</th>
            <th>6-й год</th>
            <th>7-й год</th>
          </tr>
        </thead>
        <tbody className="table-cells">
          {/* ОПЕРАЦИОННЫЕ ПОСТУПЛЕНИЯ */}
          <tr>
            <td className="table-fields__name">ОПЕРАЦИОННЫЕ ПОСТУПЛЕНИЯ</td>
            <td className="cell">{formatNumber(model.sumEarnings)}</td>
            {years.map((y) => (
              <td
                key={y}
                className={`cell ${negativeClass(model.earnings?.[y])}`}
              >
                {formatNumber(model.earnings?.[y])}
              </td>
            ))}
          </tr>
          {/* ОПЕРАЦИОННЫЕ РАСХОДЫ */}
          <tr>
            <td className="table-fields__name">ОПЕРАЦИОННЫЕ РАСХОДЫ</td>
            <td className="cell">{formatNumber(model.sumOperatingExpenses)}</td>
            {years.map((y) => (
              <td
                key={y}
                className={`cell ${negativeClass(model.operatingExpenses?.[y])}`}
              >
                {formatNumber(model.operatingExpenses?.[y])}
              </td>
            ))}
          </tr>
          {/* ОПЕРАЦИОННАЯ ПРИБЫЛЬ (ОП) – жирный */}
          <tr>
            <td className="table-fields__name cell__total">
              ОПЕРАЦИОННАЯ ПРИБЫЛЬ (ОП)
            </td>
            <td
              className={`cell cell__total ${negativeClass(model.sumGrossProfit)}`}
            >
              {formatNumber(model.sumGrossProfit)}
            </td>
            {years.map((y) => (
              <td
                key={y}
                className={`cell cell__total ${negativeClass(model.grossProfit?.[y])}`}
              >
                {formatNumber(model.grossProfit?.[y])}
              </td>
            ))}
          </tr>
          {/* Рентабельность по ОП */}
          <tr>
            <td className="table-fields__name cell__total-effectiveness">
              Рентабельность по ОП
            </td>
            <td
              className={`cell cell__total-effectiveness ${negativePercentClass(model.meanProfitabilityGP)}`}
            >
              {formatPercent(model.meanProfitabilityGP)}
            </td>
            {years.map((y) => (
              <td
                key={y}
                className={`cell cell__total-effectiveness ${negativePercentClass(model.profitabilityGP?.[y])}`}
              >
                {formatPercent(model.profitabilityGP?.[y])}
              </td>
            ))}
          </tr>
          {/* ПРОЦЕНТЫ ПО КРЕДИТАМ */}
          <tr>
            <td className="table-fields__name">ПРОЦЕНТЫ ПО КРЕДИТАМ</td>
            <td className={`cell ${negativeClass(model.sumInterest)}`}>
              {formatNumber(model.sumInterest)}
            </td>
            {years.map((y) => (
              <td
                key={y}
                className={`cell ${negativeClass(model.interest?.[y])}`}
              >
                {formatNumber(model.interest?.[y])}
              </td>
            ))}
          </tr>
          {/* НАЛОГИ* */}
          <tr>
            <td className="table-fields__name">НАЛОГИ*</td>
            <td className={`cell ${negativeClass(model.sumTaxes)}`}>
              {formatNumber(model.sumTaxes)}
            </td>
            {years.map((y) => (
              <td key={y} className={`cell ${negativeClass(model.taxes?.[y])}`}>
                {formatNumber(model.taxes?.[y])}
              </td>
            ))}
          </tr>
          {/* ЧИСТАЯ ПРИБЫЛЬ – жирный */}
          <tr>
            <td className="table-fields__name cell__total">ЧИСТАЯ ПРИБЫЛЬ</td>
            <td
              className={`cell cell__total ${negativeClass(model.sumNetProfit)}`}
            >
              {formatNumber(model.sumNetProfit)}
            </td>
            {years.map((y) => (
              <td
                key={y}
                className={`cell cell__total ${negativeClass(model.netProfit?.[y])}`}
              >
                {formatNumber(model.netProfit?.[y])}
              </td>
            ))}
          </tr>
          {/* Рентабельность продаж */}
          <tr>
            <td className="table-fields__name cell__total-effectiveness">
              Рентабельность продаж
            </td>
            <td
              className={`cell cell__total-effectiveness ${negativePercentClass(model.meanProfitabilityNT)}`}
            >
              {formatPercent(model.meanProfitabilityNT)}
            </td>
            {years.map((y) => (
              <td
                key={y}
                className={`cell cell__total-effectiveness ${negativePercentClass(model.profitabilityNP?.[y])}`}
              >
                {formatPercent(model.profitabilityNP?.[y])}
              </td>
            ))}
          </tr>
          {/* Пустая строка-разделитель */}
          <tr id="empty-row-spacer">
            <td colSpan="9"> </td>
          </tr>
          {/* Эффективность вложений (прогноз) */}
          <tr>
            <td className="table-fields__name cell__total-effectiveness">
              Эффективность вложений (прогноз)
            </td>
            <td
              className={`cell cell__total-effectiveness ${negativePercentClass(model.meanProfitabilityI)}`}
            >
              {formatPercent(model.meanProfitabilityI)}
            </td>
            {years.map((y) => (
              <td
                key={y}
                className={`cell cell__total-effectiveness ${negativePercentClass(model.profitabilityI?.[y])}`}
              >
                {formatPercent(model.profitabilityI?.[y])}
              </td>
            ))}
          </tr>
          {/* Эталонная ставка для сравнения */}
          <tr>
            <td className="table-fields__name cell__total-effectiveness">
              Эталонная ставка для сравнения **
            </td>
            <td className="cell cell__total-effectiveness">
              {formatPercent(model.interestDepositYear?.[1])}
            </td>
            {years.map((y) => (
              <td key={y} className="cell cell__total-effectiveness">
                {formatPercent(model.interestDepositYear?.[y])}
              </td>
            ))}
          </tr>
          {/* Предполагаемый доход от Бизнеса */}
          <tr>
            <td className="table-fields__name">
              Предполагаемый доход от Бизнеса
            </td>
            <td className={`cell ${negativeClass(model.sumNetProfit)}`}>
              {formatNumber(model.sumNetProfit)}
            </td>
            {years.map((y) => (
              <td
                key={y}
                className={`cell ${negativeClass(model.netProfit?.[y])}`}
              >
                {formatNumber(model.netProfit?.[y])}
              </td>
            ))}
          </tr>
          {/* Доходность от консервативных инструментов */}
          <tr id="last-row">
            <td className="table-fields__name">
              Доходность от консервативных инструментов **
            </td>
            <td className={`cell ${negativeClass(model.sumDeposit)}`}>
              {formatNumber(model.sumDeposit)}
            </td>
            {years.map((y) => (
              <td
                key={y}
                className={`cell ${negativeClass(model.depositYear?.[y])}`}
              >
                {formatNumber(model.depositYear?.[y])}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
      <div className="table-footnote">
        * Налоги рассчитаны ориентировочно, исходя из применения УСН. Вид
        деятельности по ОКВЭД 93.13 "Деятельность фитнес-центров" освобождается
        от НДС на основании ст. 149 п. 2 пп. 14.1 НК РФ. Система налогообложения
        УСН "Доходы" (6%) или "Доходы минус расходы" (15%) выбирается
        автоматически по наиболее выгодному варианту. Расчет актуален на 2025
        год. Возможны изменения налогового законодательства. <br />
        **Эталонная ставка для сравнения рассчитывается как ключевая ставка
        минус 2 процентных пункта, что соответствует доходности{" "}
        <strong>консервативных финансовых инструментов</strong>.
      </div>
    </div>
  );
};

export default ProfitLossTable;
